module.exports = __webpack_public_path__ + "2c754e9cf2f7bf848d6b1ae01910d947.jpg";